import React from 'react';

export const NotFound = () => {
   return (
     <div style={{ padding: '5%', textAlign: 'center' }}>
        <h1>OOPS!!404 Not Found</h1>
     </div>
   );
};
